
      var _rect, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 360,
  height: 360,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17.884,
  y: 46.051,
  width: 86,
  height: 52,
  rx: 7,
  transform: "rotate(2 17.884 46.051)",
  stroke: "#000",
  strokeWidth: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m61.828 29.034-.265-.015-.266-.007a8.975 8.975 0 0 0-6.582 2.75L38.3 48.764l44.974 1.57-15.188-18.107a8.964 8.964 0 0 0-6.258-3.194zm-4.235 5.505.172-.17.179-.16a5 5 0 0 1 6.719.205l.184.188c.06.064.118.13.175.197l9.416 11.225-27.02-.943 10.175-10.542z",
  fill: "#000"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 62.09,
  cy: 26.582,
  r: 9,
  transform: "rotate(2 62.09 26.582)",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.01,
  d: "m43.4 88.968 1.153-32.98 32.98 1.152-1.152 32.98-32.98-1.152z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.752 85.92a1.366 1.366 0 0 1-1.312-1.074c-1.089-4.985-5.235-8.756-10.352-9.415l-.053 1.514a2.407 2.407 0 0 1-1.568 2.164 2.762 2.762 0 0 1-2.925-.521l-6.713-6.203a2.369 2.369 0 0 1-.783-1.84 2.369 2.369 0 0 1 .91-1.782l7.129-5.733a2.763 2.763 0 0 1 2.995-.301c.89.407 1.447 1.3 1.414 2.269l-.055 1.581c7.68.857 13.427 7.375 13.237 15.01a13.76 13.76 0 0 1-.541 3.351 1.366 1.366 0 0 1-1.383.98z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"360\" height=\"360\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"17.884\" y=\"46.051\" width=\"86\" height=\"52\" rx=\"7\" transform=\"rotate(2 17.884 46.051)\" stroke=\"#000000\" stroke-width=\"4\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m61.828 29.034-.265-.015-.266-.007a8.975 8.975 0 0 0-6.582 2.75L38.3 48.764l44.974 1.57-15.188-18.107a8.964 8.964 0 0 0-6.258-3.194zm-4.235 5.505.172-.17.179-.16a5 5 0 0 1 6.719.205l.184.188c.06.064.118.13.175.197l9.416 11.225-27.02-.943 10.175-10.542z\" fill=\"#000000\"/>\r\n    <circle cx=\"62.09\" cy=\"26.582\" r=\"9\" transform=\"rotate(2 62.09 26.582)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path opacity=\".01\" d=\"m43.4 88.968 1.153-32.98 32.98 1.152-1.152 32.98-32.98-1.152z\" fill=\"#000000\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.752 85.92a1.366 1.366 0 0 1-1.312-1.074c-1.089-4.985-5.235-8.756-10.352-9.415l-.053 1.514a2.407 2.407 0 0 1-1.568 2.164 2.762 2.762 0 0 1-2.925-.521l-6.713-6.203a2.369 2.369 0 0 1-.783-1.84 2.369 2.369 0 0 1 .91-1.782l7.129-5.733a2.763 2.763 0 0 1 2.995-.301c.89.407 1.447 1.3 1.414 2.269l-.055 1.581c7.68.857 13.427 7.375 13.237 15.01a13.76 13.76 0 0 1-.541 3.351 1.366 1.366 0 0 1-1.383.98z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-error.411ca53966e5ebc69ba765742ade13e5.svg"),
        {
          React: SvgIconError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      